export default "__VITE_ASSET__cb92045a__"